import { cilAccountLogout, cilMoon, cilSun, cilUser } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import {
  CAvatar,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react-pro'
import React from 'react'
import { MobileView } from 'react-device-detect'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { THEME } from 'src/actions/actionType'
import CAN from 'src/casl/can'
import { DARK, LIGHT } from 'src/constants/Constants'
import { MENU_PROFILE } from 'src/constants/PermissionConstants'
import { isDarkTheme } from 'src/selectors/ThemeSelector'
import { logout } from '../../actions'

const AppHeaderDropdown = () => {
  const { t } = useTranslation('common')
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const Auth = useSelector((state) => state.auth)
  const isDark = useSelector(isDarkTheme)
  const initials = Auth?.first_name?.at(0) + Auth?.last_name?.at(0)
  isDark ? document.body.classList.add('dark-theme') : document.body.classList.remove('dark-theme')

  const handleLogout = () => {
    dispatch(logout())
    navigate('/login')
  }

  return (
    <CDropdown variant="nav-item" autoClose={true} alignment="end">
      <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
        <CAvatar color="avatar dark:bg-opacity-10">{initials}</CAvatar>
      </CDropdownToggle>
      <CDropdownMenu className="pt-0">
        <CDropdownHeader className="bg-light dark:bg-white dark:bg-opacity-10 fw-semibold py-2">
          {t('account')}
        </CDropdownHeader>
        {CAN(MENU_PROFILE) && (
          <CDropdownItem
            role="button"
            onClick={() => {
              navigate('/profile')
            }}
          >
            <CIcon icon={cilUser} className="me-2" />
            {t('profile')}
          </CDropdownItem>
        )}
        <MobileView>
          <CDropdownItem
            role="button"
            onClick={() => dispatch({ type: THEME, theme: isDark ? LIGHT : DARK })}
          >
            <CIcon icon={isDark ? cilMoon : cilSun} className="me-2" />
            {t(isDark ? 'dark-theme' : 'light-theme')}
          </CDropdownItem>
        </MobileView>
        <CDropdownDivider />
        <CDropdownItem role="button" onClick={handleLogout}>
          <CIcon icon={cilAccountLogout} className="me-2" />
          {t('logout')}
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
